import { GET_WORDBOARDS } from './mutation-types';

export default {
  [GET_WORDBOARDS](state, data) {
    state.wordboards = data.wordboards;
    state.count = data.count;
    state.lastFilter = data.lastFilter;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/wordboard/mutations.js